export default __webpack_public_path__ + "static/media/medical.edbaccf0.jpg";